import { FC, PropsWithChildren } from 'react';
import { FlexGridColumn } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import classes from './styles/listTileContentLayout.module.css';

const ListTileContentLayout: FC<PropsWithChildren> = ({ children }) => {
	return (
		<FlexGridColumn
			grow
			shrink
			wrappedText
			className={classes.root}
		>
			{children}
		</FlexGridColumn>
	);
};

export { ListTileContentLayout };
